module.exports = __webpack_public_path__ + "media/TNP.32ef0464.mp4";